import PropTypes from '../_util/vue-types';
export default () => ({
    visibilityHeight: PropTypes.number,
    // onClick?: React.MouseEventHandler<any>;
    target: PropTypes.func,
    prefixCls: PropTypes.string,
    onClick: PropTypes.func,
});
